import { isUndefined } from './isUndefined'
import { not } from './not'

export const isNotUndefined = not(isUndefined)
